import { useCallback } from 'react'

import { RenderReportIndicator } from 'app/common/templates-next/report-template'
import useCallbackRef from 'app/common/hooks/useCallbackRef'


type Props = {
  reportFileID: string
  onCancel?: () => void
  onFileDownload: (reportFileID: string) => Promise<boolean | null>
  onCheckStatus: () => Promise<number | null>
  onGeneratedFileID?: (id: string) => void
}

const FileExtractor = ({
  reportFileID,
  onCancel,
  onFileDownload,
  onCheckStatus,
  onGeneratedFileID,
}: Props) => {
  const onGeneratedFileIDRef = useCallbackRef(onGeneratedFileID)
  const onFileDownloadRef = useCallbackRef(onFileDownload)
  const onCancelRef = useCallbackRef(onCancel)
  const handleSuccess = useCallback(async () => {
    const res = await onFileDownloadRef.current?.(reportFileID)
    if (res) {
      onGeneratedFileIDRef.current?.(reportFileID)
    }
  }, [onFileDownloadRef, onGeneratedFileIDRef, reportFileID])

  const handleStop = useCallback(async () => {
    onCancelRef.current?.()
  }, [onCancelRef])

  return (
    <RenderReportIndicator
      reportID={reportFileID}
      interval={500}
      onCancel={onCancel}
      onCheckStatus={onCheckStatus}
      onStopProgress={handleStop}
      onSuccessProgress={handleSuccess}
    />
  )
}

export default FileExtractor
